import { validatePort } from "@/modules/network/validatePort.ts";
import { t } from "@lingui/core/macro";

export { validatePort };

export function validateSourcePort(
    value: number,
    forwarding_rules: { source_port: number }[],
    rulesContainSelf: boolean,
) {
    const portResult = validatePort(value);
    if (portResult !== undefined) {
        return portResult;
    }

    const found = forwarding_rules.filter((item) => item.source_port === value);
    return (rulesContainSelf ? found.length > 1 : found.length > 0) ? t`Source port must be unique` : undefined;
}
